import { Component, Vue, Prop } from "vue-property-decorator";

import EventBus from "../../utils/event-bus";
import { EVENT_BUS } from "../../common/constants";
@Component({

})
export default class BaseEditComponent extends Vue {
    @Prop({ default: false })
    isLoading: boolean;
    @Prop({ default: false })
    isDisable: boolean;
    @Prop({ default: 'Title', required: false })
    title: string;
    @Prop({ default: '' })
    icon: string;
    @Prop({ default: 'SAVE' })
    saveActionText: string;
    @Prop({ type: [String, Number]}) itemId;
    @Prop({ type: Boolean, default: false }) cancelVisible;
    @Prop({ type: Boolean, default: true }) visibleAction;

    canForceSave :boolean = false
    handleSave() {
        this.$emit('save');
    }
    handleCancel() {
        this.$emit('cancel');
    }

    handleForceSave() {
        EventBus.$emit(EVENT_BUS.PROPERTY.FORCE_SAVE);
    }

    mounted() {        
        EventBus.$on(EVENT_BUS.COMMON.LOADED_TRANSALTED, () => {
            this.$forceUpdate()
        });

        EventBus.$on(EVENT_BUS.PROPERTY.CAN_FORCE_SAVE, (value :boolean) => {
            this.canForceSave = value
         }); 
    }
}